<template>
  <v-card 
    outlined 
    elevation="2" 
    :color="color"
  >      
    <v-card-text>
      <v-row>
        <v-col cols="9">
          <span class="text-h4 font-weight-bold white--text">{{ value }}</span>
        </v-col>
        <v-col cols="3">
          <v-icon 
            x-large 
            color="white"
          >
            {{ icon }}
          </v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="mt-2">
          <span class="text-h6 font-weight-bold white--text">{{ label }}</span>        
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    color: String,
    icon: String,
    value: Number,
    label: String,
  },
};
</script>
